export default __webpack_public_path__ + "static/media/amazon.0a8be1f5.png";